import React, { useState } from 'react';

const RESUME_URL = 'https://drive.google.com/file/d/1pK0nLPePrEtZkrpqajLdGeJlG9Khs2Rt/view?usp=drive_link';
const RESUME_EMBED = 'https://drive.google.com/file/d/1pK0nLPePrEtZkrpqajLdGeJlG9Khs2Rt/preview';
const RESUME_DOWNLOAD = 'https://drive.google.com/uc?export=download&id=1pK0nLPePrEtZkrpqajLdGeJlG9Khs2Rt';

export default function ResumePreview() {
  const [loaded, setLoaded] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <section id="resume" style={{ background: 'transparent' }}>
      <div className="inn">
        <div className="reveal">
          <div style={{ fontFamily: "var(--mono)", fontSize: '0.75rem', color: 'var(--accent-color)', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: '0.8rem' }}>// resume</div>
          <h2 style={{ fontSize: 'clamp(2rem,4vw,3rem)', fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.1, marginBottom: '1rem', color: 'var(--text-primary)' }}>
            My <span style={{ fontFamily: "var(--serif)", fontStyle: 'italic', fontWeight: 400, color: 'var(--accent-color)' }}>Resume</span>
          </h2>
          <p style={{ fontSize: '1rem', color: 'var(--text-muted)', maxWidth: 560, lineHeight: 1.7, marginBottom: '2rem' }}>View or download my full resume- no redirects, right here.</p>
        </div>

        <div className="reveal" style={{ background: 'var(--bg)', border: '1px solid var(--border-color)', borderRadius: 20, overflow: 'hidden', marginTop: '2rem' }}>
          {/* Toolbar */}
          <div style={{ padding: '1rem 1.5rem', borderBottom: '1px solid var(--border-color)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.8rem', background: 'var(--card-bg)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--accent-glow)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>📄</div>
              <div>
                <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--text-primary)' }}>Vikash_Gautam_Resume.pdf</div>
                <div style={{ fontFamily: "var(--mono)", fontSize: '0.7rem', color: 'var(--text-muted)' }}>Full Stack Developer · 2026</div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '0.7rem', flexWrap: 'wrap' }}>
              <button onClick={() => setExpanded(!expanded)} style={{
                fontFamily: "var(--sans)", fontSize: '0.8rem', fontWeight: 600,
                padding: '0.5rem 1.1rem', borderRadius: 100,
                background: 'transparent', border: '1.5px solid var(--border-color)',
                color: 'var(--text-primary)', cursor: 'pointer', transition: 'all 0.2s',
              }}>
                {expanded ? '↑ Collapse' : '↕ Expand'}
              </button>
              <a href={RESUME_URL} target="_blank" rel="noreferrer" style={{
                fontFamily: "var(--sans)", fontSize: '0.8rem', fontWeight: 600,
                padding: '0.5rem 1.1rem', borderRadius: 100,
                background: 'transparent', border: '1.5px solid var(--border-color)',
                color: 'var(--text-primary)', textDecoration: 'none', display: 'flex', alignItems: 'center'
              }}>
                🔗 Open
              </a>
              <a href={RESUME_DOWNLOAD} target="_blank" rel="noreferrer" style={{
                fontFamily: "var(--sans)", fontSize: '0.8rem', fontWeight: 700,
                padding: '0.5rem 1.1rem', borderRadius: 100,
                background: 'var(--accent-color)', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center'
              }}>
                ↓ Download
              </a>
            </div>
          </div>

          {/* PDF Embed */}
          <div style={{ position: 'relative', height: expanded ? 900 : 520, transition: 'height 0.4s ease', background: 'var(--card-bg)' }}>
            {!loaded && (
              <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1rem', background: 'var(--bg)' }}>
                <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid var(--accent-glow)', borderTopColor: 'var(--accent-color)', animation: 'spin 0.8s linear infinite' }} />
                <div style={{ fontFamily: "var(--mono)", fontSize: '0.78rem', color: 'var(--text-muted)' }}>Loading resume...</div>
              </div>
            )}
            <iframe
              src={RESUME_EMBED}
              width="100%"
              height="100%"
              style={{ border: 'none', display: 'block', opacity: loaded ? 1 : 0, transition: 'opacity 0.3s' }}
              title="Vikash Gautam Resume"
              onLoad={() => setLoaded(true)}
              allow="autoplay"
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </section>
  );
}